<div class="view">
  <div class="head">
    <app-breadcrumb [constructor_name]="constructor.name"></app-breadcrumb>
  </div>
  <div class="body">
    <div>
      <img
        src="https://wikipapa.org/images/varscout.png"
        style="object-fit: contain; background-size: cover"
        width="100%"
      />
    </div>
    <br />
    <br />
    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around center"
      [style.padding]="'0% 15%'"
    >
      <a
        mat-raised-button
        href="https://play.google.com/store/apps/details?id=org.varscout.app&hl=es_PE&gl=US"
        style="
          margin-right: 1vw;
          background: #5ea845;
          color: white;
          font-size: 2em;
          line-height: 2em;
          height: auto;
          width: auto;
          border-radius: 1.2em;
          padding: 0em 4em;
        "
      >
        Descárgalo AQUÍ
      </a>
    </div>
    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around center"
      [style.padding]="'0% 15%'"
    >
      <div>o ingresa al <b>Play Store</b> de tu teléfono</div>
    </div>

    <!-- == -->
    <br />
    <div [style.padding]="'0% 2.5%'">
      <div>
        <p class="p1">Creación de usuario</p>
      </div>
    </div>

    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around center"
      [style.padding]="'0% 2.5%'"
    >
      <div
        fxFlex="33.3%"
        fxFlex.sm="100%"
        fxFlex.xs="100%"
        [style.padding]="'0em 1em'"
      >
        <div fxFlex="50%">
          <img
            src="https://wikipapa.org/images/1-1.png"
            style="object-fit: contain; background-size: cover"
            width="180em"
          />
        </div>

        <div fxFlex="50%" [style.padding]="'0em 0.5em'">
          <br />
          <br />
          <img
            src="https://wikipapa.org/images/01.png"
            style="object-fit: contain; background-size: cover"
            width="25em"
          />
          <p class="p2">
            Crear una cuenta de usuario. Permitir que el aplicativo acceda a su
            dispositivo
          </p>
        </div>
      </div>

      <div
        fxFlex="33.3%"
        fxFlex.sm="100%"
        fxFlex.xs="100%"
        [style.padding]="'0em 1em'"
      >
        <div fxFlex="50%">
          <img
            src="https://wikipapa.org/images/1-2.png"
            style="object-fit: contain; background-size: cover"
            width="180em"
          />
        </div>

        <div fxFlex="50%" [style.padding]="'0em 0.5em'">
          <br />
          <br />
          <img
            src="https://wikipapa.org/images/02.png"
            style="object-fit: contain; background-size: cover"
            width="30em"
          />
          <p class="p2">
            Seleccionar una variedad predeterminada, se observa todas las
            características morfológicas de la misma
          </p>
        </div>
      </div>

      <div
        fxFlex="33.3%"
        fxFlex.sm="100%"
        fxFlex.xs="100%"
        [style.padding]="'0em 1em'"
      >
        <div fxFlex="50%">
          <img
            src="https://wikipapa.org/images/1-3.png"
            style="object-fit: contain; background-size: cover"
            width="180em"
          />
        </div>

        <div fxFlex="50%" [style.padding]="'0em 0.5em'">
          <br />
          <br />
          <img
            src="https://wikipapa.org/images/03.png"
            style="object-fit: contain; background-size: cover"
            width="35em"
          />
          <p class="p2">
            Agregar una nueva variedad y/o características morfológicas de la
            flor y tubérculo
          </p>
        </div>
      </div>
    </div>

    <!-- == -->
    <br /><br />
    <div [style.padding]="'0% 2.5%'">
      <div>
        <p class="p1">Seleccionar o agregar variedad</p>
      </div>
    </div>

    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around center"
      [style.padding]="'0% 2.5%'"
    >
      <div
        fxFlex="33.3%"
        fxFlex.sm="100%"
        fxFlex.xs="100%"
        [style.padding]="'0em 1em'"
      >
        <div fxFlex="50%">
          <img
            src="https://wikipapa.org/images/2-1.png"
            style="object-fit: contain; background-size: cover"
            width="180em"
          />
        </div>

        <div fxFlex="50%" [style.padding]="'0em 0.5em'">
          <br />
          <br />
          <img
            src="https://wikipapa.org/images/01.png"
            style="object-fit: contain; background-size: cover"
            width="25em"
          />
          <p class="p2">Seleccione el cultivo (papa)</p>
        </div>
      </div>

      <div
        fxFlex="33.3%"
        fxFlex.sm="100%"
        fxFlex.xs="100%"
        [style.padding]="'0em 1em'"
      >
        <div fxFlex="50%">
          <img
            src="https://wikipapa.org/images/2-2.png"
            style="object-fit: contain; background-size: cover"
            width="180em"
          />
        </div>

        <div fxFlex="50%" [style.padding]="'0em 0.5em'">
          <br />
          <br />
          <img
            src="https://wikipapa.org/images/02.png"
            style="object-fit: contain; background-size: cover"
            width="30em"
          />
          <p class="p2">
            Buscar el nombre de una variedad. Se muestran todas las
            caracteristicas de la variedad
          </p>
        </div>
      </div>

      <div
        fxFlex="33.3%"
        fxFlex.sm="100%"
        fxFlex.xs="100%"
        [style.padding]="'0em 1em'"
      >
        <div fxFlex="50%">
          <img
            src="https://wikipapa.org/images/2-3.png"
            style="object-fit: contain; background-size: cover"
            width="180em"
          />
        </div>

        <div fxFlex="50%" [style.padding]="'0em 0.5em'">
          <br />
          <br />
          <img
            src="https://wikipapa.org/images/03.png"
            style="object-fit: contain; background-size: cover"
            width="35em"
          />
          <p class="p2">
            Agregar nombre de la nueva variedad, puede agregar caracteristicas
            de la variedad
          </p>
        </div>
      </div>
    </div>

    <!-- == -->
    <br /><br />
    <div [style.padding]="'0% 2.5%'">
      <div>
        <p class="p1">Agregar observación de variedad</p>
      </div>
    </div>

    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around center"
      [style.padding]="'0% 2.5%'"
    >
      <div
        fxFlex="25%"
        fxFlex.sm="100%"
        fxFlex.xs="100%"
        [style.padding]="'0em 1em'"
      >
        <div fxFlex="65%">
          <img
            src="https://wikipapa.org/images/3-1.png"
            style="object-fit: contain; background-size: cover"
            width="180em"
          />
        </div>

        <div fxFlex="35%" [style.padding]="'0em 0.5em'">
          <br />
          <br />
          <img
            src="https://wikipapa.org/images/01.png"
            style="object-fit: contain; background-size: cover"
            width="25em"
          />
          <p class="p2">
            Se muestra el nombre de la variedad seleccionada o agregada
          </p>
        </div>
      </div>

      <div
        fxFlex="25%"
        fxFlex.sm="100%"
        fxFlex.xs="100%"
        [style.padding]="'0em 1em'"
      >
        <div fxFlex="65%">
          <img
            src="https://wikipapa.org/images/3-2.png"
            style="object-fit: contain; background-size: cover"
            width="180em"
          />
        </div>

        <div fxFlex="35%" [style.padding]="'0em 0.5em'">
          <br />
          <br />
          <img
            src="https://wikipapa.org/images/02.png"
            style="object-fit: contain; background-size: cover"
            width="30em"
          />
          <p class="p2">
            Se puede tomar una o varias fotos. Agregar una etiqueta a la foto
          </p>
        </div>
      </div>

      <div
        fxFlex="25%"
        fxFlex.sm="100%"
        fxFlex.xs="100%"
        [style.padding]="'0em 1em'"
      >
        <div fxFlex="65%">
          <img
            src="https://wikipapa.org/images/3-3.png"
            style="object-fit: contain; background-size: cover"
            width="180em"
          />
        </div>

        <div fxFlex="35%" [style.padding]="'0em 0.5em'">
          <br />
          <br />
          <img
            src="https://wikipapa.org/images/03.png"
            style="object-fit: contain; background-size: cover"
            width="35em"
          />
          <p class="p2">
            La ubicación se registra automaticamente. Seleccionar monitoreo
          </p>
        </div>
      </div>

      <div
        fxFlex="25%"
        fxFlex.sm="100%"
        fxFlex.xs="100%"
        [style.padding]="'0em 1em'"
      >
        <div fxFlex="65%">
          <img
            src="https://wikipapa.org/images/3-4.png"
            style="object-fit: contain; background-size: cover"
            width="180em"
          />
        </div>

        <div fxFlex="35%" [style.padding]="'0em 0.5em'">
          <br />
          <br />
          <img
            src="https://wikipapa.org/images/03.png"
            style="object-fit: contain; background-size: cover"
            width="40em"
          />
          <p class="p2">Registrar datos del agricultor y guardar</p>
        </div>
      </div>
    </div>

    <!-- == -->

    <br /><br /><br /><br />
  </div>
</div>
